/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { BenefitNameEnum } from "Constants/BenefitConstants";
import { TenantTypesEnum } from "Constants/TenantTypes";
import { IBenefit } from "Interfaces/Benefits/IBenefit";
import { IFilterValue } from "Interfaces/IFilterValue";

import { IBenefitState } from "./IBenefitState";

export const getBenefits = (benefitState: IBenefitState): IBenefit[] => benefitState.benefits;
export const isLoadingBenefits = (benefitState: IBenefitState): boolean =>
  benefitState.isLoadingBenefits;
export const getLoadBenefitsError = (benefitState: IBenefitState): string =>
  benefitState.loadBenefitsError;
export const getCurrentPage = (benefitState: IBenefitState): number => benefitState.currentPage;
export const getPageSize = (benefitState: IBenefitState): number => benefitState.pageSize;
export const getSearchText = (benefitState: IBenefitState): string => benefitState.searchText;
export const getFilteredCount = (benefitState: IBenefitState): number => benefitState.filteredCount;
export const getUnclaimedCount = (benefitState: IBenefitState): number =>
  benefitState.unclaimedCount;
export const getBenefitsFilterValues = (benefitState: IBenefitState): IFilterValue[] =>
  benefitState.benefitsFilterValues;
export const getCurrentTenant = (benefitState: IBenefitState): TenantTypesEnum | undefined =>
  benefitState.currentTenant;
export const getCurrentBenefitName = (benefitState: IBenefitState): BenefitNameEnum | undefined =>
  benefitState.currentBenefitName;
